module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fiscalYear"
    }
  }, [_vm._v("Fiscal Year")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('span', {
    attrs: {
      "id": "fiscalYear"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.fyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "employmentStatus"
    }
  }, [_vm._v("Employment Status")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "employmentStatus",
      "disabled": ""
    },
    model: {
      value: (_vm.employmentStatus),
      callback: function($$v) {
        _vm.employmentStatus = $$v
      },
      expression: "employmentStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "leaveType"
    }
  }, [_vm._v("Leave Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.leaveTypeList,
      "optionLabel": "value",
      "placeholder": "--Select--",
      "id": "leaveType"
    },
    model: {
      value: (_vm.leaveType),
      callback: function($$v) {
        _vm.leaveType = $$v
      },
      expression: "leaveType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "leaveAllowed"
    }
  }, [_vm._v("Leave Allowed")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "leaveAllowed"
    },
    model: {
      value: (_vm.leaveAllowed),
      callback: function($$v) {
        _vm.leaveAllowed = $$v
      },
      expression: "leaveAllowed"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "actualLeaveValue"
    }
  }, [_vm._v("Actual Leave Value")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "actualLeaveValue"
    },
    model: {
      value: (_vm.actualLeaveValue),
      callback: function($$v) {
        _vm.actualLeaveValue = $$v
      },
      expression: "actualLeaveValue"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addLeaveAllocation.apply(null, arguments)
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afe07fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/leaveAllocation.vue
// module id = 2160
// module chunks = 0